import { DateObject } from './reusables/date-object';
import { Status } from './reusables/status';

/**
 * Blueprint for the reminder entity.
 */
export class ImportHistory {
  public id: number;
  public itemCount: number;
  public itemCounter: ItemCounter;
  public owner: ImportOwner;
  public completedAt: DateObject;
  public createdAt: DateObject;
  public type: string;
  public media: any;
  public status: Status;

  public i18nMembership: string = $localize`:@@importComponent.text.membership:Membership`;
  public i18nClubAttributes: string = $localize`:@@importComponent.text.clubAttributes:Club Attributes`;
  public i18nCompleted: string = $localize`:@@importComponent.text.completed:Completed`;
  public i18nFinishedSuccess: string = $localize`:@@importComponent.text.finishedSuccess:Finished successfully`;
  public i18nFinishedError: string = $localize`:@@importComponent.text.finishedError:Finished with errors`;
  public i18nCreated: string = $localize`:@@importComponent.text.created:Created`;

  public statuses: Array<any> = [
    { value: 'success', status: this.i18nFinishedSuccess, class: 'esf-tag--success' },
    { value: 'error', status: this.i18nFinishedError, class: 'esf-tag--warning' },
    { value: 'created', status: this.i18nCreated, class: 'esf-tag--info' }
  ];

  public types: Array<any> = [
    { value: 'club-attributes', text: this.i18nClubAttributes },
    { value: 'membership', text: this.i18nMembership },
  ];

  constructor(importHistory: any) {
    this.id = importHistory.id;
    this.itemCount = importHistory.itemCount;
    this.itemCounter = importHistory.itemCounter ? new ItemCounter(importHistory.itemCounter) : null;
    this.owner = new ImportOwner(importHistory.owner);
    this.completedAt = new DateObject(importHistory.completedAt, 'dd.MM.yyyy HH:mm');
    this.createdAt = new DateObject(importHistory.createdAt, 'dd.MM.yyyy HH:mm');
    this.type = importHistory.type;
    this.media = importHistory.media;
    this.status = this.getFullStatus(importHistory);
  }

  public getFullStatus(importHistory: any): any {
    let fullStatus;
    if (!importHistory.itemCounter) {
      fullStatus = this.statuses.find(el => el.value === 'created');
      return new Status(fullStatus);
    }
    const percentage = Math.round(importHistory.itemCounter.progressPercentage);
    const hasFailed = importHistory.itemCounter.failed > 0;
    if (percentage === 100) {
      if (hasFailed) {
        fullStatus = this.statuses.find(el => el.value === 'error');
      } else {
        fullStatus = this.statuses.find(el => el.value === 'success');
      }
      return new Status(fullStatus);
    } else {
      fullStatus = { value: percentage, status: `${percentage}% ${this.i18nCompleted}`, class: 'esf-tag--info' };
      return new Status(fullStatus);
    }
  }

  get translatedType(): any {
    const translatedType = this.types.find(el => this.type === el.value);
    return translatedType ? translatedType.text : this.type;
  }
}

export class ImportOwner {
  public id: number;
  public firstName: string;
  public lastName: string;


  constructor(owner: any) {
    this.id = owner.id;
    this.firstName = owner.firstName;
    this.lastName = owner.lastName;
  }

  get fullName(): string {
    return `${this.firstName} ${this.lastName}`;
  }
}

export class ItemCounter {
  public total: number;
  public failed: number;
  public successful: number;
  public progressPercentage: number;


  constructor(itemCounter: any) {
    this.total = itemCounter.total;
    this.failed = itemCounter.failed;
    this.successful = itemCounter.successful;
    this.progressPercentage = itemCounter.progressPercentage;
  }
}
